import React from 'react';
import { Link } from 'react-router-dom';
export function AIFeed() {
  return;
}